// import Select from 'react-select';
// import { useEffect, useMemo, useState } from 'react';
// import { useTranslation } from 'react-i18next';
// import { useNavigate } from 'react-router-dom';

// import Loading from '@components/Shared/Loader/Loading';
// import { Card, CardFooter, CardHeader } from '@components/card/card';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { initReport, getReportPagedData, selectReport, setReportRequest } from '@store/DynamicSlice/reportTableSlice';
// import ReportExportExcelModal, { type ExportColumn } from '@Helper/ReportPaged/ReportExportExcelModal';
// import ReportPagination from '@Helper/ReportPaged/ReportPagination';

// // ✅ استخدم هوك المخازن/الفروع الموجود عندك (عدّل الاستيراد/الأسماء إذا تختلف)
// import useGlChartLookups from '@hooks/Finance/ChartAccountsDetails/useGlChartLookups';
// import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';

// type InventoryTransferReportRequestDto = {
//   pageIndex?: number;
//   pageSize?: number;

//   fromDate?: string | null;
//   toDate?: string | null;

//   trCode?: string | null;

//   inventoryId?: string | null;
//   inventoryToId?: string | null;

//   branchId?: string | null;
//   branchToId?: string | null;

//   trInventoryFlag?: number | null;  // 0/1 (أو null = الكل)
//   isuInventoryFlag?: number | null; // 0/1
//   recInventoryFlag?: number | null; // 0/1

//   sortColumn?: string | null;
//   sortDirection?: string | null;
// };

// type RowDto = {
//   tR_ID: string | null;
//   tR_CODE: string | null;
//   tR_DATE: string | null;
//   description: string | null;
//   tR_INVENTORY_FLAG: number;

//   inventorY_FROM: string | null;
//   inventorY_FROM2: string | null;
//   brancH_FROM: string | null;
//   brancH_FROM2: string | null;

//   inventorY_TO: string | null;
//   inventorY_TO2: string | null;
//   brancH_TO: string | null;
//   brancH_TO2: string | null;

//   isU_ID: string | null;
//   isU_CODE: string | null;
//   isU_DATE: string | null;
//   isU_INVENTORY_FLAG: number;

//   reC_ID: string | null;
//   reC_CODE: string | null;
//   reC_DATE: string | null;
//   reC_INVENTORY_FLAG: number;
// };

// const REPORT_KEY = 'RPT_InventoryTransferReport';
// const ENDPOINT = 'Inv/InventoryTransferReport_Paged';

// const safe = (v: any, fallback = '—') => (v === null || v === undefined || v === '' ? fallback : String(v));

// const formatNumber = (num: number, digits: number = 2) =>
//   new Intl.NumberFormat('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(num || 0);

// const formatDate = (dateString: string | null) => {
//   if (!dateString) return '—';
//   const d = new Date(dateString);
//   return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
// };

// const getOptId = (opt: any): string | null => {
//   const v = opt?.value ?? opt?.id ?? opt?.ID ?? opt?.key ?? null;
//   return v ? String(v) : null;
// };

// const isoOrNull = (d: any) => {
//   if (!d) return null;
//   if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d)) return `${d}T00:00:00.000Z`;
//   if (d instanceof Date) return d.toISOString();
//   return null;
// };

// const cleanNulls = <T extends Record<string, any>>(obj: T): Partial<T> => {
//   const out: any = {};
//   for (const [k, v] of Object.entries(obj)) {
//     if (v === null || v === undefined || v === '') continue;
//     out[k] = v;
//   }
//   return out;
// };

// const getCodePrefix = (code?: string | null) => {
//   const c = (code ?? '').trim().toUpperCase();
//   if (!c) return null;
//   const m = c.match(/^[A-Z]+/);
//   return m?.[0] ?? null;
// };

// const getTypeLabelFromCode = (code?: string | null, isAr?: boolean) => {
//   const p = getCodePrefix(code);
//   if (!p) return '—';

//   const map: Record<string, { ar: string; en: string }> = {
//     MOV: { ar: 'تحويل مخزني', en: 'Inventory Transfer' },
//     MOI: { ar: 'صرف تحويل مخزني', en: 'Transfer Issue' },
//     MOR: { ar: 'استلام تحويل مخزني', en: 'Transfer Receipt' }
//   };

//   const x = map[p];
//   return x ? (isAr ? x.ar : x.en) : p;
// };

// // ✅ عدّل المسارات حسب Routes الفعلية عندك
// const buildDocLink = (code?: string | null, id?: string | null) => {
//   if (!id) return null;
//   const p = getCodePrefix(code);

//   switch (p) {
//     case 'MOV':
//       return `/inv/inventory-transfer/${id}`;
//     case 'MOI':
//       return `/inv/inventory-transfer/issue/${id}`;
//     case 'MOR':
//       return `/inv/inventory-transfer/receipt/${id}`;
//     default:
//       return `/inv/documents/${id}`;
//   }
// };

// const InventoryTransferReport_Paged = () => {
//   const { t, i18n } = useTranslation();
//   const isAr = i18n.language !== 'en';

//   const dispatch = useAppDispatch();
//   const navigate = useNavigate();

//   const report = useAppSelector(s => selectReport(s as any, REPORT_KEY));
//   const items = (report?.items ?? []) as RowDto[];
//   const meta = report?.meta ?? null;
//   const loading = report?.loading ?? false;
//   const error = report?.error ?? null;

//   // Branch options
//   const { OptionsBranches, loading: loadingBranches } = useGlChartLookups();

//   // Inventory options (عدّل حسب هوكك)
//   const invHook: any = useGetInventoryWithPermission?.();
//   const OptionsInventories = invHook?.OptionsInventories ?? invHook?.OptionsInventory ?? invHook?.options ?? [];
//   const loadingInventories = invHook?.loading ?? false;

//   // Filters
//   const [branchFrom, setBranchFrom] = useState<any>(null);
//   const [branchTo, setBranchTo] = useState<any>(null);
//   const [invFrom, setInvFrom] = useState<any>(null);
//   const [invTo, setInvTo] = useState<any>(null);

//   const [trCode, setTrCode] = useState<string>('');
//   const [fromDate, setFromDate] = useState<any>(null);
//   const [toDate, setToDate] = useState<any>(null);

//   // Flags: null=All, 1=Yes, 0=No
//   const flagOptions = useMemo(
//     () => [
//       { value: null, label: isAr ? 'الكل' : 'All' },
//       { value: 1, label: isAr ? 'نعم' : 'Yes' },
//       { value: 0, label: isAr ? 'لا' : 'No' }
//     ],
//     [isAr]
//   );

//   const [trFlag, setTrFlag] = useState<any>(flagOptions[0]);
//   const [isuFlag, setIsuFlag] = useState<any>(flagOptions[0]);
//   const [recFlag, setRecFlag] = useState<any>(flagOptions[0]);

//   const [showExport, setShowExport] = useState(false);

//   useEffect(() => {
//     const initialRequest: InventoryTransferReportRequestDto = {
//       pageIndex: 0,
//       pageSize: 50,
//       sortColumn: 'tR_DATE',
//       sortDirection: 'DESC'
//     };

//     dispatch(
//       initReport({
//         reportKey: REPORT_KEY,
//         endpoint: ENDPOINT,
//         initialRequest
//       })
//     );
//   }, [dispatch]);

//   const applyFilters = () => {
//     const req: InventoryTransferReportRequestDto = {
//       pageIndex: 0,
//       pageSize: ((report as any)?.request?.pageSize ?? 50) as number,

//       fromDate: isoOrNull(fromDate),
//       toDate: isoOrNull(toDate),

//       trCode: trCode?.trim() || null,

//       branchId: getOptId(branchFrom),
//       branchToId: getOptId(branchTo),

//       inventoryId: getOptId(invFrom),
//       inventoryToId: getOptId(invTo),

//       trInventoryFlag: trFlag?.value ?? null,
//       isuInventoryFlag: isuFlag?.value ?? null,
//       recInventoryFlag: recFlag?.value ?? null
//     };

//     dispatch(setReportRequest({ reportKey: REPORT_KEY, request: cleanNulls(req) as any }));
//     dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
//   };

//   const clearFilters = () => {
//     setBranchFrom(null);
//     setBranchTo(null);
//     setInvFrom(null);
//     setInvTo(null);
//     setTrCode('');
//     setFromDate(null);
//     setToDate(null);

//     setTrFlag(flagOptions[0]);
//     setIsuFlag(flagOptions[0]);
//     setRecFlag(flagOptions[0]);

//     const resetReq: InventoryTransferReportRequestDto = {
//       pageIndex: 0,
//       pageSize: 50,
//       sortColumn: 'tR_DATE',
//       sortDirection: 'DESC'
//     };

//     dispatch(setReportRequest({ reportKey: REPORT_KEY, request: resetReq as any }));
//   };

//   const openDoc = (code?: string | null, id?: string | null) => {
//     const url = buildDocLink(code, id);
//     if (!url) return;
//     navigate(url);
//   };

//   const exportColumns: ExportColumn<RowDto>[] = [
//     { headerAr: 'تاريخ التحويل', headerEn: 'Transfer Date', value: r => formatDate(r.tR_DATE) },
//     { headerAr: 'نوع', headerEn: 'Type', value: r => getTypeLabelFromCode(r.tR_CODE, true) },
//     { headerAr: 'كود التحويل', headerEn: 'Transfer Code', value: r => r.tR_CODE || '' },
//     { headerAr: 'الوصف', headerEn: 'Description', value: r => r.description || '' },

//     { headerAr: 'من المخزن', headerEn: 'From Inventory', value: r => (isAr ? r.inventorY_FROM2 || r.inventorY_FROM : r.inventorY_FROM || r.inventorY_FROM2) || '' },
//     { headerAr: 'من الفرع', headerEn: 'From Branch', value: r => (isAr ? r.brancH_FROM2 || r.brancH_FROM : r.brancH_FROM || r.brancH_FROM2) || '' },

//     { headerAr: 'إلى المخزن', headerEn: 'To Inventory', value: r => (isAr ? r.inventorY_TO2 || r.inventorY_TO : r.inventorY_TO || r.inventorY_TO2) || '' },
//     { headerAr: 'إلى الفرع', headerEn: 'To Branch', value: r => (isAr ? r.brancH_TO2 || r.brancH_TO : r.brancH_TO || r.brancH_TO2) || '' },

//     { headerAr: 'كود الصرف', headerEn: 'Issue Code', value: r => r.isU_CODE || '' },
//     { headerAr: 'تاريخ الصرف', headerEn: 'Issue Date', value: r => formatDate(r.isU_DATE) },

//     { headerAr: 'كود الاستلام', headerEn: 'Receipt Code', value: r => r.reC_CODE || '' },
//     { headerAr: 'تاريخ الاستلام', headerEn: 'Receipt Date', value: r => formatDate(r.reC_DATE) }
//   ];

//   return (
//     <>
//       <CardHeader className='mb-3'>
//         <div className='row g-2 align-items-center'>
//           {/* From Branch */}
//           <div className='col-lg-3'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-store text-primary'></i>
//               </span>
//               <Select
//                 isLoading={loadingBranches}
//                 value={branchFrom}
//                 onChange={setBranchFrom}
//                 options={OptionsBranches}
//                 placeholder={isAr ? 'من الفرع' : 'From Branch'}
//                 isClearable
//                 isSearchable
//                 className='flex-grow-1'
//                 classNamePrefix='react-select'
//                 menuPortalTarget={document.body}
//                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//               />
//             </div>
//           </div>

//           {/* To Branch */}
//           <div className='col-lg-3'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-store text-warning'></i>
//               </span>
//               <Select
//                 isLoading={loadingBranches}
//                 value={branchTo}
//                 onChange={setBranchTo}
//                 options={OptionsBranches}
//                 placeholder={isAr ? 'إلى الفرع' : 'To Branch'}
//                 isClearable
//                 isSearchable
//                 className='flex-grow-1'
//                 classNamePrefix='react-select'
//                 menuPortalTarget={document.body}
//                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//               />
//             </div>
//           </div>

//           {/* From Inventory */}
//           <div className='col-lg-3'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-warehouse text-primary'></i>
//               </span>
//               <Select
//                 isLoading={loadingInventories}
//                 value={invFrom}
//                 onChange={setInvFrom}
//                 options={OptionsInventories}
//                 placeholder={isAr ? 'من المخزن' : 'From Inventory'}
//                 isClearable
//                 isSearchable
//                 className='flex-grow-1'
//                 classNamePrefix='react-select'
//                 menuPortalTarget={document.body}
//                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//               />
//             </div>
//           </div>

//           {/* To Inventory */}
//           <div className='col-lg-3'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-warehouse text-warning'></i>
//               </span>
//               <Select
//                 isLoading={loadingInventories}
//                 value={invTo}
//                 onChange={setInvTo}
//                 options={OptionsInventories}
//                 placeholder={isAr ? 'إلى المخزن' : 'To Inventory'}
//                 isClearable
//                 isSearchable
//                 className='flex-grow-1'
//                 classNamePrefix='react-select'
//                 menuPortalTarget={document.body}
//                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//               />
//             </div>
//           </div>

//           {/* Dates */}
//           <div className='col-lg-2'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-calendar'></i>
//               </span>
//               <input
//                 type='date'
//                 className='form-control'
//                 value={fromDate || ''}
//                 onChange={e => setFromDate(e.target.value)}
//                 placeholder={isAr ? 'من تاريخ' : 'From Date'}
//               />
//             </div>
//           </div>

//           <div className='col-lg-2'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-calendar'></i>
//               </span>
//               <input
//                 type='date'
//                 className='form-control'
//                 value={toDate || ''}
//                 onChange={e => setToDate(e.target.value)}
//                 min={fromDate || undefined}
//                 placeholder={isAr ? 'إلى تاريخ' : 'To Date'}
//               />
//             </div>
//           </div>

//           {/* trCode */}
//           <div className='col-lg-2'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-hashtag'></i>
//               </span>
//               <input
//                 type='text'
//                 className='form-control'
//                 value={trCode}
//                 onChange={e => setTrCode(e.target.value)}
//                 placeholder={isAr ? 'كود التحويل' : 'Transfer Code'}
//               />
//             </div>
//           </div>

//           {/* Flags */}
//           <div className='col-lg-2'>
//             <Select
//               value={trFlag}
//               onChange={setTrFlag}
//               options={flagOptions}
//               placeholder={isAr ? 'TR Flag' : 'TR Flag'}
//               isSearchable
//               classNamePrefix='react-select'
//               menuPortalTarget={document.body}
//               styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//             />
//           </div>

//           <div className='col-lg-2'>
//             <Select
//               value={isuFlag}
//               onChange={setIsuFlag}
//               options={flagOptions}
//               placeholder={isAr ? 'Issue Flag' : 'Issue Flag'}
//               isSearchable
//               classNamePrefix='react-select'
//               menuPortalTarget={document.body}
//               styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//             />
//           </div>

//           <div className='col-lg-2'>
//             <Select
//               value={recFlag}
//               onChange={setRecFlag}
//               options={flagOptions}
//               placeholder={isAr ? 'Receipt Flag' : 'Receipt Flag'}
//               isSearchable
//               classNamePrefix='react-select'
//               menuPortalTarget={document.body}
//               styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//             />
//           </div>

//           {/* Buttons */}
//           <div className='col-lg-2 text-end'>
//             <button
//               className='btn btn-outline-secondary me-2'
//               type='button'
//               onClick={clearFilters}
//               title={t('ClearFilters')}
//             >
//               <i className='fas fa-times fa-fw'></i>
//             </button>

//             <button className='btn btn-theme me-2' type='button' onClick={applyFilters} title={t('ApplyFilters')}>
//               <i className='fas fa-filter fa-fw'></i>
//             </button>

//             <button
//               className='btn btn-outline-success'
//               type='button'
//               onClick={() => setShowExport(true)}
//               title={t('Export')}
//               disabled={loading || items.length === 0}
//             >
//               <i className='fas fa-file-excel fa-fw'></i>
//             </button>
//           </div>
//         </div>
//       </CardHeader>

//       <Card className='mb-4'>
//         <Loading loading={loading} error={error}>
//           <div className='table-responsive' style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
//             <table className='table table-hover mb-0'>
//               <thead className='sticky-top' style={{ top: 0, zIndex: 10 }}>
//                 <tr className='bg-theme bg-opacity-35' style={{ backdropFilter: 'blur(20px)' }}>
//                   <th className='small' style={{ minWidth: 110 }}>{isAr ? 'تاريخ التحويل' : 'TR Date'}</th>
//                   <th className='small' style={{ minWidth: 130 }}>{isAr ? 'النوع' : 'Type'}</th>
//                   <th className='small' style={{ minWidth: 140 }}>{isAr ? 'كود التحويل' : 'TR Code'}</th>
//                   <th className='small' style={{ minWidth: 260 }}>{isAr ? 'الوصف' : 'Description'}</th>

//                   <th className='small' style={{ minWidth: 220 }}>{isAr ? 'من المخزن' : 'From Inventory'}</th>
//                   <th className='small' style={{ minWidth: 160 }}>{isAr ? 'من الفرع' : 'From Branch'}</th>

//                   <th className='small' style={{ minWidth: 220 }}>{isAr ? 'إلى المخزن' : 'To Inventory'}</th>
//                   <th className='small' style={{ minWidth: 160 }}>{isAr ? 'إلى الفرع' : 'To Branch'}</th>

//                   <th className='small' style={{ minWidth: 140 }}>{isAr ? 'كود الصرف' : 'Issue Code'}</th>
//                   <th className='small' style={{ minWidth: 110 }}>{isAr ? 'تاريخ الصرف' : 'Issue Date'}</th>

//                   <th className='small' style={{ minWidth: 140 }}>{isAr ? 'كود الاستلام' : 'Receipt Code'}</th>
//                   <th className='small' style={{ minWidth: 120 }}>{isAr ? 'تاريخ الاستلام' : 'Receipt Date'}</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {!loading && items.length > 0 ? (
//                   items.map((r, idx) => {
//                     const trName = isAr ? r.inventorY_FROM2 || r.inventorY_FROM : r.inventorY_FROM || r.inventorY_FROM2;
//                     const trTo = isAr ? r.inventorY_TO2 || r.inventorY_TO : r.inventorY_TO || r.inventorY_TO2;
//                     const brFrom = isAr ? r.brancH_FROM2 || r.brancH_FROM : r.brancH_FROM || r.brancH_FROM2;
//                     const brTo = isAr ? r.brancH_TO2 || r.brancH_TO : r.brancH_TO || r.brancH_TO2;

//                     return (
//                       <tr key={`${r.tR_ID || 'row'}-${idx}`} className='align-middle'>
//                         <td>{formatDate(r.tR_DATE)}</td>

//                         <td>
//                           <span className='badge bg-light text-dark border'>
//                             {getTypeLabelFromCode(r.tR_CODE, isAr)}
//                           </span>
//                         </td>

//                         <td>
//                           {r.tR_CODE && r.tR_ID ? (
//                             <button
//                               type='button'
//                               className='btn btn-link p-0 fw-bold text-decoration-none'
//                               onClick={() => openDoc(r.tR_CODE, r.tR_ID)}
//                               title={isAr ? 'فتح التحويل' : 'Open Transfer'}
//                             >
//                               {r.tR_CODE}
//                             </button>
//                           ) : (
//                             <span className='text-muted'>{safe(r.tR_CODE)}</span>
//                           )}
//                         </td>

//                         <td>{safe(r.description, isAr ? '—' : '—')}</td>

//                         <td>{safe(trName)}</td>
//                         <td>{safe(brFrom)}</td>

//                         <td>{safe(trTo)}</td>
//                         <td>{safe(brTo)}</td>

//                         <td>
//                           {r.isU_CODE && r.isU_ID ? (
//                             <button
//                               type='button'
//                               className='btn btn-link p-0 fw-bold text-decoration-none'
//                               onClick={() => openDoc(r.isU_CODE, r.isU_ID)}
//                               title={isAr ? 'فتح الصرف' : 'Open Issue'}
//                             >
//                               {r.isU_CODE}
//                             </button>
//                           ) : (
//                             <span className='text-muted'>{safe(r.isU_CODE)}</span>
//                           )}
//                         </td>
//                         <td>{formatDate(r.isU_DATE)}</td>

//                         <td>
//                           {r.reC_CODE && r.reC_ID ? (
//                             <button
//                               type='button'
//                               className='btn btn-link p-0 fw-bold text-decoration-none'
//                               onClick={() => openDoc(r.reC_CODE, r.reC_ID)}
//                               title={isAr ? 'فتح الاستلام' : 'Open Receipt'}
//                             >
//                               {r.reC_CODE}
//                             </button>
//                           ) : (
//                             <span className='text-muted'>{safe(r.reC_CODE)}</span>
//                           )}
//                         </td>
//                         <td>{formatDate(r.reC_DATE)}</td>
//                       </tr>
//                     );
//                   })
//                 ) : !loading ? (
//                   <tr>
//                     <td colSpan={12} className='text-center py-5'>
//                       <div className='text-muted'>
//                         <i className='fas fa-file-invoice fa-3x mb-3 opacity-50'></i>
//                         <h6>{t('NoData')}</h6>
//                         <small>{t('TryChangingFilters')}</small>
//                       </div>
//                     </td>
//                   </tr>
//                 ) : null}
//               </tbody>
//             </table>
//           </div>
//         </Loading>

//         <CardFooter>
//           <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
//             <ReportPagination reportKey={REPORT_KEY} maxVisiblePages={3} showItemsPerPage={true} />

//             {!loading && items.length > 0 && (
//               <div className='text-muted small'>
//                 <i className='fas fa-info-circle me-1'></i>
//                 {isAr ? 'عرض' : 'Showing'} {items.length} {isAr ? 'من' : 'of'} {meta?.totalRows || 0}{' '}
//                 {isAr ? 'سجل' : 'records'}
//               </div>
//             )}
//           </div>
//         </CardFooter>
//       </Card>

//       <ReportExportExcelModal
//         show={showExport}
//         onHide={() => setShowExport(false)}
//         reportKey={REPORT_KEY}
//         endpoint={ENDPOINT}
//         columns={exportColumns}
//         exportPageSize={4000}
//         sheetName={({ isAr }) => (isAr ? 'تقرير التحويلات المخزنية' : 'Inventory Transfer Report')}
//         fileName={({ reportKey }) => `${reportKey}_${new Date().toISOString().slice(0, 10)}.xlsx`}
//       />
//     </>
//   );
// };

// export default InventoryTransferReport_Paged;

// RPT_InventoryTransferReport.tsx
import React, { useEffect, useMemo, useState } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Loading from '@components/Shared/Loader/Loading';
import { Card, CardFooter, CardHeader } from '@components/card/card';

import { useAppDispatch, useAppSelector } from '@store/hooks';
import { initReport, getReportPagedData, selectReport, setReportRequest } from '@store/DynamicSlice/reportTableSlice';

import ReportExportExcelModal, { type ExportColumn } from '@Helper/ReportPaged/ReportExportExcelModal';
import ReportPagination from '@Helper/ReportPaged/ReportPagination';

import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';

/** =========================
 * REQUEST SHAPE
 * ========================= */
type InventoryTransferReportRequestDto = {
  pageIndex?: number;
  pageSize?: number;

  fromDate?: string | null;
  toDate?: string | null;

  trCode?: string | null;

  inventoryId?: string | null;
  inventoryToId?: string | null;

  branchId?: string | null;
  branchToId?: string | null;

  trInventoryFlag?: number | null;  // 0/1/null
  isuInventoryFlag?: number | null; // 0/1/null
  recInventoryFlag?: number | null; // 0/1/null

  sortColumn?: string | null;
  sortDirection?: string | null; // ASC/DESC
};

/** =========================
 * RESPONSE SHAPE
 * ========================= */
type RowDto = {
  tR_ID: string | null;
  tR_CODE: string | null;
  tR_DATE: string | null;
  description: string | null;
  tR_INVENTORY_FLAG: number | null;

  inventorY_FROM: string | null;
  inventorY_FROM2: string | null;
  brancH_FROM: string | null;
  brancH_FROM2: string | null;

  inventorY_TO: string | null;
  inventorY_TO2: string | null;
  brancH_TO: string | null;
  brancH_TO2: string | null;

  isU_ID: string | null;
  isU_CODE: string | null;
  isU_DATE: string | null;
  isU_INVENTORY_FLAG: number | null;

  reC_ID: string | null;
  reC_CODE: string | null;
  reC_DATE: string | null;
  reC_INVENTORY_FLAG: number | null;
};

const REPORT_KEY = 'RPT_InventoryTransferReport';
const ENDPOINT = 'Inv/InventoryTransferReport_Paged';

const safe = (v: any, fallback = '—') => (v === null || v === undefined || v === '' ? fallback : String(v));

const getOptId = (opt: any): string | null => {
  const v = opt?.value ?? opt?.id ?? opt?.ID ?? opt?.key ?? null;
  return v ? String(v) : null;
};

const isoOrNull = (d: any) => {
  if (!d) return null;
  if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d)) return `${d}T00:00:00.000Z`;
  if (d instanceof Date) return d.toISOString();
  return null;
};

const cleanNulls = <T extends Record<string, any>>(obj: T): Partial<T> => {
  const out: any = {};
  for (const [k, v] of Object.entries(obj)) {
    if (v === null || v === undefined || v === '') continue;
    out[k] = v; // ✅ يحافظ على 0 و false
  }
  return out;
};

const getLangText = (en?: string | null, ar?: string | null, isAr?: boolean) =>
  (isAr ? (ar || en) : (en || ar)) || null;

const badgeYesNo = (flag: any) => {
  if (flag === null || flag === undefined) return <span className='text-muted small'>—</span>;
  const isYes = Number(flag) === 1;
  return <span className={`badge ${isYes ? 'bg-success' : 'bg-secondary'}`}>{isYes ? 'Y' : 'N'}</span>;
};

const getCodePrefix = (code?: string | null) => {
  const c = (code ?? '').trim().toUpperCase();
  if (!c) return null;
  const m = c.match(/^[A-Z]+/);
  return m?.[0] ?? null;
};

/**
 * ✅ عدّل الروابط حسب الـ Routes عندك
 * MOV = تحويل مخزني
 * MOI = صرف تحويل
 * MOR = استلام تحويل
 */
const buildDocLink = (code?: string | null, id?: string | null) => {
  if (!id) return null;
  const p = getCodePrefix(code);

  switch (p) {
    case 'MOV':
      return `/inv/inventory-transfer/${id}`;
    case 'MOI':
      return `/inv/inventory-transfer/issue/${id}`;
    case 'MOR':
      return `/inv/inventory-transfer/receipt/${id}`;
    default:
      return `/inv/documents/${id}`;
  }
};

const InventoryTransferReport_Paged: React.FC = () => {
  const { t, i18n } = useTranslation();
  const isAr = i18n.language !== 'en';

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  // ===== Lookups (فروع/مخازن)
  const branchHook = useGetOperatingUnitWithPermission() as any;
  const OptionsBranches = branchHook?.OperatingUnitOptions ?? branchHook?.OptionsBranches ?? branchHook?.options ?? [];
  const loadingBranches = branchHook?.loading ?? false;

  const invHook = useGetInventoryWithPermission() as any;
  const OptionsInventories =
    invHook?.InventoryOptions ?? invHook?.OptionsInventories ?? invHook?.options ?? invHook?.OptionsInventory ?? [];
  const loadingInventories = invHook?.loading ?? false;

  // ===== Report State
  const report = useAppSelector(s => selectReport(s as any, REPORT_KEY));
  const items = (report?.items ?? []) as RowDto[];
  const meta = report?.meta ?? null;
  const loading = report?.loading ?? false;
  const error = report?.error ?? null;

  // ===== Filters
  const [branchFrom, setBranchFrom] = useState<any>(null);
  const [branchTo, setBranchTo] = useState<any>(null);
  const [invFrom, setInvFrom] = useState<any>(null);
  const [invTo, setInvTo] = useState<any>(null);

  const [trCode, setTrCode] = useState<string>('');
  const [fromDate, setFromDate] = useState<any>(null);
  const [toDate, setToDate] = useState<any>(null);

  const flagOptions = useMemo(
    () => [
      { value: null, label: isAr ? 'الكل' : 'All' },
      { value: 1, label: isAr ? 'نعم' : 'Yes' },
      { value: 0, label: isAr ? 'لا' : 'No' }
    ],
    [isAr]
  );

  const [trFlag, setTrFlag] = useState<any>(flagOptions[0]);
  const [isuFlag, setIsuFlag] = useState<any>(flagOptions[0]);
  const [recFlag, setRecFlag] = useState<any>(flagOptions[0]);

  const [showExport, setShowExport] = useState(false);

  useEffect(() => {
    const initialRequest: InventoryTransferReportRequestDto = {
      pageIndex: 0,
      pageSize: 50,
      sortColumn: 'tR_DATE',
      sortDirection: 'DESC'
    };

    dispatch(
      initReport({
        reportKey: REPORT_KEY,
        endpoint: ENDPOINT,
        initialRequest
      })
    );
  }, [dispatch]);

  const openDoc = (code?: string | null, id?: string | null) => {
    const url = buildDocLink(code, id);
    if (!url) return;
    navigate(url);
  };

  const applyFilters = () => {
    const prevReq = (((report as any)?.request ?? {}) as InventoryTransferReportRequestDto) || {};

    const nextReq: InventoryTransferReportRequestDto = {
      ...prevReq,
      pageIndex: 0,
      pageSize: prevReq.pageSize ?? 50,

      fromDate: isoOrNull(fromDate),
      toDate: isoOrNull(toDate),

      trCode: trCode?.trim() || null,

      branchId: getOptId(branchFrom),
      branchToId: getOptId(branchTo),

      inventoryId: getOptId(invFrom),
      inventoryToId: getOptId(invTo),

      trInventoryFlag: trFlag?.value ?? null,
      isuInventoryFlag: isuFlag?.value ?? null,
      recInventoryFlag: recFlag?.value ?? null
    };

    dispatch(setReportRequest({ reportKey: REPORT_KEY, request: cleanNulls(nextReq) as any }));
    dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
  };

  const clearFilters = () => {
    setBranchFrom(null);
    setBranchTo(null);
    setInvFrom(null);
    setInvTo(null);

    setTrCode('');
    setFromDate(null);
    setToDate(null);

    setTrFlag(flagOptions[0]);
    setIsuFlag(flagOptions[0]);
    setRecFlag(flagOptions[0]);

    const resetReq: InventoryTransferReportRequestDto = {
      pageIndex: 0,
      pageSize: 50,
      sortColumn: 'tR_DATE',
      sortDirection: 'DESC'
    };

    dispatch(setReportRequest({ reportKey: REPORT_KEY, request: resetReq as any }));
  };

  const totals = useMemo(() => {
    return {
      transfersCount: items.length,
      issuesCount: items.filter(x => !!x.isU_ID).length,
      receiptsCount: items.filter(x => !!x.reC_ID).length
    };
  }, [items]);

  const exportColumns: ExportColumn<RowDto>[] = [
    { headerAr: 'كود التحويل', headerEn: 'TR Code', value: r => r.tR_CODE || '' },
    { headerAr: 'تاريخ التحويل', headerEn: 'TR Date', value: r => (r.tR_DATE ? r.tR_DATE.split('T')[0] : '') },
    { headerAr: 'الوصف', headerEn: 'Description', value: r => r.description || '' },

    { headerAr: 'من الفرع', headerEn: 'From Branch', value: r => getLangText(r.brancH_FROM, r.brancH_FROM2, isAr) || '' },
    { headerAr: 'من المخزن', headerEn: 'From Inventory', value: r => getLangText(r.inventorY_FROM, r.inventorY_FROM2, isAr) || '' },

    { headerAr: 'إلى الفرع', headerEn: 'To Branch', value: r => getLangText(r.brancH_TO, r.brancH_TO2, isAr) || '' },
    { headerAr: 'إلى المخزن', headerEn: 'To Inventory', value: r => getLangText(r.inventorY_TO, r.inventorY_TO2, isAr) || '' },

    { headerAr: 'كود الصرف', headerEn: 'Issue Code', value: r => r.isU_CODE || '' },
    { headerAr: 'تاريخ الصرف', headerEn: 'Issue Date', value: r => (r.isU_DATE ? r.isU_DATE.split('T')[0] : '') },

    { headerAr: 'كود الاستلام', headerEn: 'Receipt Code', value: r => r.reC_CODE || '' },
    { headerAr: 'تاريخ الاستلام', headerEn: 'Receipt Date', value: r => (r.reC_DATE ? r.reC_DATE.split('T')[0] : '') }
  ];

  return (
    <>
      <CardHeader className='mb-3'>
        <div className='row g-2 align-items-center mb-2'>
          {/* From Branch */}
          <div className='col-lg-3'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-store text-primary'></i>
              </span>
              <Select
                isLoading={loadingBranches}
                value={branchFrom}
                onChange={setBranchFrom}
                options={OptionsBranches}
                placeholder={isAr ? 'من الفرع' : 'From Branch'}
                isClearable
                isSearchable
                className='flex-grow-1'
                classNamePrefix='react-select'
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </div>

          {/* To Branch */}
          <div className='col-lg-3'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-store text-warning'></i>
              </span>
              <Select
                isLoading={loadingBranches}
                value={branchTo}
                onChange={setBranchTo}
                options={OptionsBranches}
                placeholder={isAr ? 'إلى الفرع' : 'To Branch'}
                isClearable
                isSearchable
                className='flex-grow-1'
                classNamePrefix='react-select'
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </div>

          {/* From Inventory */}
          <div className='col-lg-3'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-warehouse text-primary'></i>
              </span>
              <Select
                isLoading={loadingInventories}
                value={invFrom}
                onChange={setInvFrom}
                options={OptionsInventories}
                placeholder={isAr ? 'من المخزن' : 'From Inventory'}
                isClearable
                isSearchable
                className='flex-grow-1'
                classNamePrefix='react-select'
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </div>

          {/* To Inventory */}
          <div className='col-lg-3'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-warehouse text-warning'></i>
              </span>
              <Select
                isLoading={loadingInventories}
                value={invTo}
                onChange={setInvTo}
                options={OptionsInventories}
                placeholder={isAr ? 'إلى المخزن' : 'To Inventory'}
                isClearable
                isSearchable
                className='flex-grow-1'
                classNamePrefix='react-select'
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </div>
        </div>

        <div className='row g-2 align-items-center'>
          {/* From Date */}
          <div className='col-lg-2'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-calendar'></i>
              </span>
              <input
                type='date'
                className='form-control'
                value={fromDate || ''}
                onChange={e => setFromDate(e.target.value)}
                placeholder={isAr ? 'من تاريخ' : 'From Date'}
              />
            </div>
          </div>

          {/* To Date */}
          <div className='col-lg-2'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-calendar'></i>
              </span>
              <input
                type='date'
                className='form-control'
                value={toDate || ''}
                onChange={e => setToDate(e.target.value)}
                min={fromDate || undefined}
                placeholder={isAr ? 'إلى تاريخ' : 'To Date'}
              />
            </div>
          </div>

          {/* TR Code */}
          <div className='col-lg-2'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-hashtag'></i>
              </span>
              <input
                type='text'
                className='form-control'
                value={trCode}
                onChange={e => setTrCode(e.target.value)}
                placeholder={isAr ? 'كود التحويل' : 'Transfer Code'}
              />
            </div>
          </div>

          {/* Flags */}
          {/* <div className='col-lg-2'>
            <Select
              value={trFlag}
              onChange={setTrFlag}
              options={flagOptions}
              placeholder={isAr ? 'TR Flag' : 'TR Flag'}
              isSearchable
              classNamePrefix='react-select'
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
            />
          </div>

          <div className='col-lg-2'>
            <Select
              value={isuFlag}
              onChange={setIsuFlag}
              options={flagOptions}
              placeholder={isAr ? 'ISU Flag' : 'ISU Flag'}
              isSearchable
              classNamePrefix='react-select'
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
            />
          </div>

          <div className='col-lg-2'>
            <Select
              value={recFlag}
              onChange={setRecFlag}
              options={flagOptions}
              placeholder={isAr ? 'REC Flag' : 'REC Flag'}
              isSearchable
              classNamePrefix='react-select'
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
            />
          </div> */}

          {/* Buttons */}
          <div className='col-lg-12 text-end mt-1'>
            <button
              className='btn btn-outline-secondary me-2'
              type='button'
              onClick={clearFilters}
              title={t('ClearFilters')}
            >
              <i className='fas fa-times fa-fw'></i>
            </button>

            <button className='btn btn-theme me-2' type='button' onClick={applyFilters} title={t('ApplyFilters')}>
              <i className='fas fa-filter fa-fw'></i> {isAr ? 'بحث' : 'Search'}
            </button>

            <button
              className='btn btn-outline-success'
              type='button'
              onClick={() => setShowExport(true)}
              title={t('Export')}
              disabled={loading || items.length === 0}
            >
              <i className='fas fa-file-excel fa-fw'></i>
            </button>
          </div>
        </div>
      </CardHeader>

      <Card className='mb-4'>
        <Loading loading={loading} error={error}>
          {/* ===== TABLE (نفس ستايل الجدول اللي أرسلته) ===== */}
          <div className='table-responsive' style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
            <table className='table table-hover table-bordered mb-0'>
              <thead className='sticky-top align-middle' style={{ top: 0, zIndex: 10 }}>
                {/* Row 1: Groups */}
                <tr className='bg-theme bg-opacity-35 text-center' style={{ backdropFilter: 'blur(20px)' }}>
                  <th className='small text-primary' colSpan={4}>
                    {isAr ? 'معلومات التحويل' : 'Transfer Info'}
                  </th>
                  <th className='small text-info' colSpan={2}>
                    {isAr ? 'من' : 'From'}
                  </th>
                  <th className='small text-warning' colSpan={2}>
                    {isAr ? 'إلى' : 'To'}
                  </th>
                  <th className='small text-danger' colSpan={3}>
                    {isAr ? 'الصرف' : 'Issue'}
                  </th>
                  <th className='small text-success' colSpan={3}>
                    {isAr ? 'الاستلام' : 'Receipt'}
                  </th>
                </tr>

                {/* Row 2: Columns */}
                <tr className='bg-theme bg-opacity-25 text-center' style={{ backdropFilter: 'blur(20px)' }}>
                  {/* TR */}
                  <th className='small' style={{ minWidth: 120 }}>{isAr ? 'كود' : 'Code'}</th>
                  <th className='small' style={{ minWidth: 105 }}>{isAr ? 'تاريخ' : 'Date'}</th>
                  <th className='small' style={{ minWidth: 260 }}>{isAr ? 'الوصف' : 'Description'}</th>
                  <th className='small' style={{ minWidth: 70 }}>TR</th>

                  {/* From */}
                  <th className='small' style={{ minWidth: 170 }}>{isAr ? 'الفرع' : 'Branch'}</th>
                  <th className='small' style={{ minWidth: 230 }}>{isAr ? 'المخزن' : 'Inventory'}</th>

                  {/* To */}
                  <th className='small' style={{ minWidth: 170 }}>{isAr ? 'الفرع' : 'Branch'}</th>
                  <th className='small' style={{ minWidth: 230 }}>{isAr ? 'المخزن' : 'Inventory'}</th>

                  {/* Issue */}
                  <th className='small' style={{ minWidth: 120 }}>{isAr ? 'كود' : 'Code'}</th>
                  <th className='small' style={{ minWidth: 105 }}>{isAr ? 'تاريخ' : 'Date'}</th>
                  <th className='small' style={{ minWidth: 70 }}>ISU</th>

                  {/* Receipt */}
                  <th className='small' style={{ minWidth: 120 }}>{isAr ? 'كود' : 'Code'}</th>
                  <th className='small' style={{ minWidth: 105 }}>{isAr ? 'تاريخ' : 'Date'}</th>
                  <th className='small' style={{ minWidth: 70 }}>REC</th>
                </tr>
              </thead>

              <tbody>
                {!loading && items.length > 0 ? (
                  items.map((r, idx) => {
                    const fromBranch = getLangText(r.brancH_FROM, r.brancH_FROM2, isAr);
                    const fromInv = getLangText(r.inventorY_FROM, r.inventorY_FROM2, isAr);

                    const toBranch = getLangText(r.brancH_TO, r.brancH_TO2, isAr);
                    const toInv = getLangText(r.inventorY_TO, r.inventorY_TO2, isAr);

                    return (
                      <tr key={`${r.tR_ID || 'row'}-${idx}`} className='align-middle text-center'>
                        {/* TR Code */}
                        <td>
                          {r.tR_CODE && r.tR_ID ? (
                            <button
                              type='button'
                              className='btn btn-link p-0 fw-bold text-primary text-decoration-none'
                              onClick={() => openDoc(r.tR_CODE, r.tR_ID)}
                              title={isAr ? 'فتح التحويل' : 'Open transfer'}
                            >
                              {r.tR_CODE}
                            </button>
                          ) : (
                            <span className='text-muted'>{safe(r.tR_CODE)}</span>
                          )}
                        </td>

                        {/* TR Date */}
                        <td className='small'>{r.tR_DATE ? r.tR_DATE.split('T')[0] : '—'}</td>

                        {/* Description */}
                        <td className='text-start'>
                          <span className='small'>{safe(r.description)}</span>
                        </td>

                        {/* TR Flag */}
                        {/* <td>{badgeYesNo(r.tR_INVENTORY_FLAG)}</td> */}
                        <td>{""}</td>

                        {/* From */}
                        <td className='text-start'>{safe(fromBranch)}</td>
                        <td className='text-start'>{safe(fromInv)}</td>

                        {/* To */}
                        <td className='text-start'>{safe(toBranch)}</td>
                        <td className='text-start'>{safe(toInv)}</td>

                        {/* Issue Code */}
                        <td>
                          {r.isU_CODE && r.isU_ID ? (
                            <button
                              type='button'
                              className='btn btn-link p-0 fw-bold text-danger text-decoration-none'
                              onClick={() => openDoc(r.isU_CODE, r.isU_ID)}
                              title={isAr ? 'فتح الصرف' : 'Open issue'}
                            >
                              {r.isU_CODE}
                            </button>
                          ) : (
                            <span className='text-muted'>{safe(r.isU_CODE)}</span>
                          )}
                        </td>

                        {/* Issue Date */}
                        <td className='small'>{r.isU_DATE ? r.isU_DATE.split('T')[0] : '—'}</td>

                        {/* Issue Flag */}
                        {/* <td>{badgeYesNo(r.isU_INVENTORY_FLAG)}</td> */}
                        <td>{""}</td>

                        {/* Receipt Code */}
                        <td>
                          {r.reC_CODE && r.reC_ID ? (
                            <button
                              type='button'
                              className='btn btn-link p-0 fw-bold text-success text-decoration-none'
                              onClick={() => openDoc(r.reC_CODE, r.reC_ID)}
                              title={isAr ? 'فتح الاستلام' : 'Open receipt'}
                            >
                              {r.reC_CODE}
                            </button>
                          ) : (
                            <span className='text-muted'>{safe(r.reC_CODE)}</span>
                          )}
                        </td>

                        {/* Receipt Date */}
                        <td className='small'>{r.reC_DATE ? r.reC_DATE.split('T')[0] : '—'}</td>

                        {/* Receipt Flag */}
                        {/* <td>{badgeYesNo(r.reC_INVENTORY_FLAG)}</td> */}
                        <td>{""}</td>
                      </tr>
                    );
                  })
                ) : !loading ? (
                  <tr>
                    <td colSpan={14} className='text-center py-5'>
                      <div className='text-muted'>
                        <i className='fas fa-file-invoice fa-3x mb-3 opacity-50'></i>
                        <h6>{t('NoData')}</h6>
                       </div>
                    </td>
                  </tr>
                ) : null}
              </tbody>

              {!loading && items.length > 0 && (
                <tfoot className='fw-bold bg-secondary bg-opacity-30 text-center'>
                  <tr>
                    <td colSpan={4} className='text-end text-primary'>
                      {isAr ? 'عدد التحويلات:' : 'Transfers Count:'}
                    </td>
                    <td colSpan={2} className='text-start'>
                      <span className='badge bg-primary'>{totals.transfersCount}</span>
                    </td>

                    <td colSpan={2}></td>

                    <td colSpan={2} className='text-end text-danger'>
                      {isAr ? 'عدد الصرف:' : 'Issues Count:'}
                    </td>
                    <td className='text-start'>
                      <span className='badge bg-danger'>{totals.issuesCount}</span>
                    </td>

                    <td colSpan={2} className='text-end text-success'>
                      {isAr ? 'عدد الاستلام:' : 'Receipts Count:'}
                    </td>
                    <td className='text-start'>
                      <span className='badge bg-success'>{totals.receiptsCount}</span>
                    </td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        </Loading>

        <CardFooter>
          <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
            <ReportPagination reportKey={REPORT_KEY} maxVisiblePages={3} showItemsPerPage={true} />

            {!loading && items.length > 0 && (
              <div className='text-muted small'>
                <i className='fas fa-info-circle me-1'></i>
                {isAr ? 'عرض' : 'Showing'} {items.length} {isAr ? 'من' : 'of'} {meta?.totalRows || 0}{' '}
                {isAr ? 'سجل' : 'records'}
              </div>
            )}
          </div>
        </CardFooter>
      </Card>

      <ReportExportExcelModal
        show={showExport}
        onHide={() => setShowExport(false)}
        reportKey={REPORT_KEY}
        endpoint={ENDPOINT}
        columns={exportColumns}
        exportPageSize={4000}
        sheetName={({ isAr }) => (isAr ? 'تقرير التحويلات المخزنية' : 'Inventory Transfer Report')}
        fileName={({ reportKey }) => `${reportKey}_${new Date().toISOString().slice(0, 10)}.xlsx`}
      />
    </>
  );
};

export default InventoryTransferReport_Paged;